<template>
  <div class="flex">

    <div class="row no-gutters row-bordered row-border-light">

      <!-- ========================================================= -->
      <!-- CHART -->
      <!-- ========================================================= -->

      <div
        :style="{ display }"
        class="col-md-5 pt-0 px-2 py-3"
      >

        <button
          @click="close()"
          type="button"
          class="btn btn-dark btn-sm"
          style="
            font-size: 10px;
            float: right;
            padding: 0px 6px;
          "
        >
          &times;
        </button>

        <div
          class="py-4"
          style="padding-bottom: 0rem !important;"
        >
          <div class="border border-dark">

            <vue-highcharts
              :options="optionsChartBar"
              ref="lineChartsBar"
              style="height: 67vh;"
              :redraw="true"
            />

          </div>
        </div>

      </div>


      <!-- ========================================================= -->
      <!-- MAP -->
      <!-- ========================================================= -->

      <div
        class="py-3 px-2"
        :class="col"
        style="padding-bottom: 0.5rem !important;"
      >

        <div class="border border-dark">

          <div
            class="p-1"
            style="
              height: 70vh;
              background-color: white;
            "
          >

            <l-map
              :zoom="zoom"
              :center="center"
              :options="mapOptions"
              ref="myMap"
            >

              <!-- ================================================= -->
              <!-- BASEMAP -->
              <!-- ================================================= -->

              <l-tile-layer
                :url="url"
              />


              <!-- ================================================= -->
              <!-- LEFT CONTROL -->
              <!-- ================================================= -->

              <l-control>

                <div class="d-flex flex-column">

                  <b-form-select
                    v-model="selectedCountry"
                    class="mb-3"
                    @change="ChangeCountry"
                    style="
                      background-color: #00948a !important;
                      color: #fff;
                    "
                  >

                    <template #first>

                      <b-form-select-option
                        :value="null"
                        disabled
                      >
                        -- Select country --
                      </b-form-select-option>

                    </template>

                    <b-form-select-option
                      v-for="(countryName, index) in countryNameArray"
                      :key="index"
                      :value="countryName"
                    >
                      {{ countryName }}
                    </b-form-select-option>

                  </b-form-select>


                  <!-- ============================================= -->
                  <!-- LEGEND -->
                  <!-- ============================================= -->

                  <div
                    v-if="selectedCountry"
                    class="rounded p-3"
                    style="
                      font: 14px/16px Arial, Helvetica, sans-serif;
                      background: rgba(255,255,255,0.9);
                    "
                  >

                    <div>

                      <br>

                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#3d4ebe;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          0 - (0 - 3)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          0 - (0)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          0 - (0)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          0 - (0 - 18)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0 - 0.1
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#5a77df;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          1 - (4 - 9)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          1 - (1 - 3)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          1 - (1 - 4)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          1 - (19 - 55)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.11 - 0.2
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#7fa1f7;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          2 - (10 - 18)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          2 - (4 - 7)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          2 - (5 - 7)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          2 - (56 - 115)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.21 - 0.3
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#9fbffc;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          3 - (19 - 34)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          3 - (8 - 10)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          3 - (8 - 10)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          3 - (116 - 197)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.31 - 0.4
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#c0d3f3;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          4 - (35 - 58)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          4 - (11 - 15)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          4 - (11 - 15)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          4 - (198 - 202)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.41 - 0.5
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#d5dbe4;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          5 - (59 - 100)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          5 - (16 - 22)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          5 - (16 - 22)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          5 - (203 - 313)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.51 - 0.6
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#f5a98e;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          6 - (101 - 167)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          6 - (23 - 29)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          6 - (23 - 36)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          6 - (314 - 482)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.61 - 0.7
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#eb8068;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          7 - (168 - 293)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          7 - (30 - 59)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          7 - (37 - 77)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          7 - (483 - 731)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.71 - 0.8
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#d75549;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          8 - (294 - 568)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          8 - (60 - 205)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          8 - (78 - 206)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          8 - (732 - 1225)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.81 - 0.9
                        </strong>

                      </div>


                      <br>


                      <div style="display:flex;align-items:center">

                        <div
                          style="
                            background-color:#b60e2c;
                            border-radius:10px;
                            height:10px;
                            width:10px;
                            margin-right:5px;
                          "
                        />

                        <strong v-if="selectedCountry === 'Italy'">
                          9 - (&gt; 568)
                        </strong>

                        <strong v-if="selectedCountry === 'France'">
                          9 - (&gt; 205)
                        </strong>

                        <strong v-if="selectedCountry === 'Germany'">
                          9 - (&gt; 206)
                        </strong>

                        <strong v-if="selectedCountry === 'Serbia'">
                          9 - (&gt; 1225)
                        </strong>

                        <strong v-if="selectedCountry === 'Greece'">
                          0.91 - 1
                        </strong>

                      </div>

                      <br>

                    </div>

                  </div>

                </div>

              </l-control>


              <!-- ================================================= -->
              <!-- INFO CONTROL -->
              <!-- ================================================= -->

              <l-control
                position="bottomright"
                style="width:400px"
              >

                <div class="p-2 info-text">

                  <p
                    style="
                      text-align:justify;
                      font-size:12px;
                    "
                  >
                    Estimated risk of occurrence of a registered
                    mosquito-borne disease case at each cell, as
                    produced by the DVI data-driven model. The model
                    uses satellite Earth Observation data,
                    Socioeconomic data and the predictions of MAMOTH.
                  </p>

                </div>

              </l-control>


              <!-- ================================================= -->
              <!-- LOADER -->
              <!-- ================================================= -->

              <div
                v-if="tst"
                class="loader"
              />


              <!-- ================================================= -->
              <!-- COUNTRY POLYGONS -->
              <!-- ================================================= -->

              <l-polygon
                v-for="(countryData, index) in polygon.latlngs"
                :key="index + 'country'"
                ref="polygon_country"
                :lat-lngs="countryData"
                :fill-color="countryColorArray[index]"
                :color="countryColorArray[index]"
                :fill-opacity="0"
                :weight="2"
                @click="focusOnCountry(index)"
              />

              <!--
                  IMPORTANT:

                  MAMOTH rectangles are NOT rendered here using
                  <l-rectangle>.

                  They are rendered directly with Leaflet Canvas
                  inside renderMAMOTHLayer().
              -->

            </l-map>

          </div>

        </div>

      </div>

    </div>


    <!-- =========================================================== -->
    <!-- MONTH / YEAR CONTROLS -->
    <!-- =========================================================== -->

    <div
      v-if="selectedCountry"
      class="px-2"
    >

      <div class="border border-dark">

        <div
          style="
            width:100%;
            background-color:#FFFFFF;
            height:130px;
          "
        >

          <div
            class="
              row
              justify-content-between
              px-3
              align-items-center
            "
          >

            <div
              class="
                col-6
                col-md-1
                align-items-center
                mt-2
              "
            >

              <p
                style="background-color:#d6d8db;"
                class="rounded p-2"
              >
                Month:
              </p>

            </div>


            <div
              class="
                col-12
                col-md-4
                d-flex
                justify-content-center
              "
              style="width:100%;"
            >

              <!-- YEAR -->

              <b-form-select
                v-model="selectedYear"
                class="mt-2"
                style="
                  background-color:#00948a;
                  color:#fff;
                "
                @change="ChangeYear"
              >

                <template #first>

                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- Select Year --
                  </b-form-select-option>

                </template>

                <b-form-select-option
                  v-for="year in years"
                  :key="year.year"
                  :value="year.year"
                >
                  {{ year.year }}
                </b-form-select-option>

              </b-form-select>


              <!-- REGION -->

              <b-form-select
                v-model="selectedRegion"
                class="mt-2"
                style="
                  background-color:#00948a;
                  color:#fff;
                "
                @change="ChangeRegion"
              >

                <template #first>

                  <b-form-select-option
                    :value="null"
                  >
                    -- All Regions --
                  </b-form-select-option>

                </template>

                <b-form-select-option
                  v-for="region in regions_array"
                  :key="region['lau1']"
                  :value="region['lau1']"
                >
                  {{ region['lau1'] }}
                </b-form-select-option>

              </b-form-select>

            </div>

          </div>


          <!-- ===================================================== -->
          <!-- MONTH SLIDER -->
          <!-- ===================================================== -->

          <div v-if="data && value">

            <vue-slider
              class="px-4"
              style="z-index:1005;"
              ref="slider"
              v-model="value"
              :marks="true"
              :data="data"
              :data-value="'id'"
              :data-label="'name'"
              @change="ChangeWeek"
            >

              <template v-slot:step="{ active }">

                <div
                  :class="[
                    'custom-step',
                    { active }
                  ]"
                />

              </template>

            </vue-slider>

          </div>

        </div>

      </div>

    </div>


    <!-- =========================================================== -->
    <!-- ERROR MODAL -->
    <!-- =========================================================== -->

    <b-modal
      id="modal-center"
      v-model="modalError"
      centered
      title="Error"
      hide-footer
    >

      <p class="my-4">
        No Data Available
      </p>

    </b-modal>

  </div>
</template>


<script>

import {
  LMap,
  LTileLayer,
  LPolygon,
  LControl
} from 'vue2-leaflet'

import L from 'leaflet'

import axios from '../axios-auth'

import VueSlider from 'vue-slider-component'

import 'vue-slider-component/theme/default.css'

import VueHighcharts from 'vue2-highcharts'

import { MyFunctions } from '../components/colorClassificationsRISK'


export default {

  components: {

    VueHighcharts,

    VueSlider,

    LMap,

    LTileLayer,

    LPolygon,

    LControl

  },


  data() {

    return {

      /* ===========================================================
         MAP PERFORMANCE
      =========================================================== */

      mapOptions: {

        // Very important:
        // Vector layers are drawn on Canvas instead of SVG.
        preferCanvas: true,

        // Slightly reduce animation overhead.
        fadeAnimation: false,

        markerZoomAnimation: false,

        zoomAnimation: true

      },


      /*
       * Native Leaflet layer containing MAMOTH rectangles.
       *
       * Vue does NOT manage the individual rectangles anymore.
       */
      mamothLayer: null,


      /*
       * Shared Canvas renderer.
       *
       * We reuse one renderer instead of creating one canvas
       * renderer for every polygon.
       */
      mamothRenderer: null,


      /*
       * One tooltip reused by all MAMOTH cells.
       *
       * Previously every cell had its own <l-tooltip>.
       */
      mamothTooltip: null,


      /*
       * Used to cancel an old asynchronous render when:
       *
       * - month changes
       * - year changes
       * - region changes
       * - user moves map
       */
      mamothRenderVersion: 0,


      /*
       * Number of rectangles created before yielding to browser.
       *
       * Lower = smoother UI but slightly slower total render.
       * Higher = faster total render but bigger short freezes.
       */
      renderChunkSize: 500,


      /* ===========================================================
         ORIGINAL DATA
      =========================================================== */

      months_names: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],

      regions_array: [],

      selectedRegion: null,

      mamoth_data: [],

      selectedModel: 'MAMOTH',

      modalError: false,

      badweek_data: null,

      selected_country_old: null,

      countryNameArray: [],

      countryColorArray: [
        '#3388ff',
        '#3388ff',
        '#3388ff',
        '#3388ff',
        '#3388ff'
      ],

      polygon: {

        latlngs: []

      },

      pointData: null,

      display: 'none',

      nameOfSettlement: '',

      nameOfSettlementTooltip: '',

      charts: false,

      col: 'col-md-12',

      selectedYear: '2020',

      year: '',

      errorMsg: '',

      tst: true,

      Mosquitoes_Abundance_Data: '',

      dates: '',

      years: '',

      selected: null,

      selectedCountry: null,

      url:
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',

      zoom: 5,

      center: [
        43.6659,
        17.1937
      ],

      colors: [
        '#1C8BC2',
        '#8EC4CD',
        '#F7FFA7',
        '#FDE97D',
        '#FFD27D',
        '#FFC262',
        '#FBAE5F',
        '#FB7C47',
        '#F94626',
        '#D40414'
      ],

      value: null,

      data: null,


      /* ===========================================================
         HIGHCHARTS
      =========================================================== */

      optionsChartBar: {

        chart: {

          type: 'column'

        },

        title: {

          text: ''

        },

        yAxis: {

          title: {

            text: ''

          },

          tickAmount: 10

        },

        xAxis: {

          title: {

            text: 'week'

          },

          tickAmount: 10

        },

        plotOptions: {

          series: {

            shadow: true,

            borderWidth: 0,

            minPointLength: 5

          }

        },

        credits: {

          enabled: false

        },

        series: []

      },


      countryArray: [
        'Greece'
      ]

    }

  },


  /* ===============================================================
     CREATED
  =============================================================== */

  async created() {

    const user = JSON.parse(
      localStorage.getItem('user')
    )

    this.group = user.groups


    try {

      const country_geom = await axios.get(
        'entomologicalData/country/',
        {
          params: {

            group: JSON.stringify(
              this.group
            )

          }
        }
      )


      this.country = country_geom.data


      for (
        let i = 0;
        i < country_geom.data.length;
        i++
      ) {

        const currentCountry =
          this.country[i]


        if (
          !this.countryArray.includes(
            currentCountry.name
          )
        ) {

          continue

        }


        this.countryNameArray.push(
          currentCountry.name
        )


        /*
         * Use public Leaflet API instead of:
         *
         * _leaflet_id
         * _layers
         * _latlngs
         *
         * which are private Leaflet properties.
         */
        const geoJsonObject =
          JSON.parse(
            currentCountry.json
          )


        const geoJsonLayer =
          L.geoJSON(
            geoJsonObject
          )


        const layers =
          geoJsonLayer.getLayers()


        if (
          layers.length > 0 &&
          typeof layers[0].getLatLngs === 'function'
        ) {

          this.polygon.latlngs.push(
            layers[0].getLatLngs()
          )

        }

      }


      if (
        this.polygon.latlngs.length === 0
      ) {

        this.modalError = true

      }


      this.getDistRegion()

    }
    catch (error) {

      console.error(
        'Error loading country geometry:',
        error
      )

      this.modalError = true

    }
    finally {

      this.tst = false

    }

  },


  /* ===============================================================
     MOUNTED
  =============================================================== */

  mounted() {
    this.$nextTick(() => {
      if (
        !this.$refs.myMap ||
        !this.$refs.myMap.mapObject
      ) {
        return
      }

      const map = this.$refs.myMap.mapObject

      // IMPORTANT:
      // Leaflet objects must NOT be stored inside Vue data()
      this._mamothLayer = null

      this._mamothRenderer = L.canvas({
        padding: 0.5,
        tolerance: 5
      })

      this._mamothTooltip = L.tooltip({
        direction: 'top',
        sticky: true,
        opacity: 0.95,
        className: 'mamoth-tooltip'
      })

      map.on(
        'moveend',
        this.handleMapMoveEnd
      )
    })
  },


  /* ===============================================================
     DESTROY
  =============================================================== */

  beforeDestroy() {

    /*
     * Invalidate any render currently running.
     */
    this.mamothRenderVersion++


    if (
      this.$refs.myMap &&
      this.$refs.myMap.mapObject
    ) {

      const map =
        this.$refs.myMap.mapObject


      map.off(
        'moveend',
        this.handleMapMoveEnd
      )


      if (
        this.mamothLayer
      ) {

        map.removeLayer(
          this.mamothLayer
        )

      }


      if (
        this.mamothTooltip &&
        map.hasLayer(this.mamothTooltip)
      ) {

        map.removeLayer(
          this.mamothTooltip
        )

      }

    }


    this.mamothLayer = null

    this.mamothTooltip = null

    this.mamothRenderer = null

  },


  methods: {


    /* =============================================================
       MAP MOVE
    ============================================================= */

    handleMapMoveEnd() {

      /*
       * Only redraw if there are already MAMOTH data.
       */
      if (
        !this.mamoth_data ||
        !this.mamoth_data.length
      ) {

        return

      }


      this.renderMAMOTHLayer()

    },


    /* =============================================================
       CLEAR MAMOTH LAYER
    ============================================================= */

    clearMAMOTHLayer() {

      if (
        !this.$refs.myMap ||
        !this.$refs.myMap.mapObject
      ) {

        return

      }


      const map =
        this.$refs.myMap.mapObject


      if (
        this.mamothLayer
      ) {

        map.removeLayer(
          this.mamothLayer
        )

        this.mamothLayer = null

      }


      if (
        this.mamothTooltip &&
        map.hasLayer(this.mamothTooltip)
      ) {

        map.removeLayer(
          this.mamothTooltip
        )

      }

    },


    /* =============================================================
       OPTIMIZED MAMOTH RENDERER
    ============================================================= */

    async renderMAMOTHLayer() {
  if (
    !this.$refs.myMap ||
    !this.$refs.myMap.mapObject
  ) {
    return
  }

  if (
    !this.mamoth_data ||
    !this.mamoth_data.length
  ) {
    this.clearMAMOTHLayer()
    return
  }

  const map = this.$refs.myMap.mapObject

  const renderVersion =
    ++this.mamothRenderVersion

  /*
   * Remove previous layer
   */
  if (this._mamothLayer) {
    map.removeLayer(this._mamothLayer)
    this._mamothLayer = null
  }

  /*
   * Render current viewport + buffer
   */
  const visibleBounds =
    map.getBounds().pad(0.30)

  const visibleData =
    this.mamoth_data.filter(item => {
      return visibleBounds.contains([
        Number(item.y),
        Number(item.x)
      ])
    })

  console.log(
    `Rendering ${visibleData.length}/${this.mamoth_data.length} cells`
  )

  /*
   * IMPORTANT:
   * this is a LOCAL variable.
   *
   * Don't assign it to Vue state until finished,
   * and when we do assign it, use a non-reactive _property.
   */
  const newLayer = L.layerGroup()

  const renderer =
    this._mamothRenderer

  const chunkSize =
    this.renderChunkSize || 500

  for (
    let start = 0;
    start < visibleData.length;
    start += chunkSize
  ) {
    /*
     * Another render started.
     * Abort this one.
     */
    if (
      renderVersion !==
      this.mamothRenderVersion
    ) {
      newLayer.clearLayers()
      return
    }

    const end =
      Math.min(
        start + chunkSize,
        visibleData.length
      )

    for (
      let index = start;
      index < end;
      index++
    ) {
      const item =
        visibleData[index]

      const color =
        this.colors_Classification(
          item.risk_score
        )

      const rectangle =
        L.rectangle(
          item.bounds,
          {
            renderer: renderer,

            // polygon border
            color: color,
            weight: 0.3,
            opacity: 1,

            // polygon fill
            fillColor: color,
            fillOpacity: 0.8,

            interactive: true
          }
        )

      /*
       * Hover
       */
      rectangle.on(
        'mouseover',
        event => {
          if (!this._mamothTooltip) {
            return
          }

          this._mamothTooltip
            .setLatLng(event.latlng)
            .setContent(
              `${item.cell_id} : ${item.risk_score}`
            )

          if (
            !map.hasLayer(
              this._mamothTooltip
            )
          ) {
            this._mamothTooltip.addTo(map)
          }
        }
      )

      /*
       * Follow mouse
       */
      rectangle.on(
        'mousemove',
        event => {
          if (
            this._mamothTooltip &&
            map.hasLayer(
              this._mamothTooltip
            )
          ) {
            this._mamothTooltip
              .setLatLng(event.latlng)
          }
        }
      )

      /*
       * Remove tooltip
       */
      rectangle.on(
        'mouseout',
        () => {
          if (
            this._mamothTooltip &&
            map.hasLayer(
              this._mamothTooltip
            )
          ) {
            map.removeLayer(
              this._mamothTooltip
            )
          }
        }
      )

      /*
       * Click
       */
      rectangle.on(
        'click',
        () => {
          this.openChart(item)
        }
      )

      newLayer.addLayer(
        rectangle
      )
    }

    /*
     * Give the browser time to render UI.
     */
    await new Promise(resolve => {
      requestAnimationFrame(resolve)
    })
  }

  /*
   * Make sure this render is still current.
   */
  if (
    renderVersion !==
    this.mamothRenderVersion
  ) {
    newLayer.clearLayers()
    return
  }

  newLayer.addTo(map)

  /*
   * NON-REACTIVE instance property.
   */
  this._mamothLayer =
    newLayer
    },


    /* =============================================================
       GET MAMOTH YEARS + MONTHS
    ============================================================= */

    async getMAMOTHdata() {

      const token =
        localStorage.getItem('token')


      try {

        const yearsResponse =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/year/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              }

            }
          )


        this.years =
          yearsResponse.data


        if (
          !this.years ||
          !this.years.length
        ) {

          this.data = []

          this.mamoth_data = []

          this.clearMAMOTHLayer()

          return

        }


        this.selectedYear =
          this.years[
            this.years.length - 1
          ].year


        const monthsResponse =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/month/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              },

              params: {

                year:
                  this.selectedYear,

                region:
                  this.selectedRegion

              }

            }
          )


        this.data =
          monthsResponse.data.map(
            item => {

              const monthName =
                this.months_names[
                  item.month - 1
                ]


              return {

                id: monthName,

                name: monthName

              }

            }
          )


        if (
          !this.data.length
        ) {

          this.value = null

          this.mamoth_data = []

          this.clearMAMOTHLayer()

          return

        }


        this.value =
          this.data[0].id


        await this.getAllMAMOTHdata()

      }
      catch (error) {

        console.error(
          'Error loading MAMOTH metadata:',
          error
        )

        this.modalError = true

      }

    },


    /* =============================================================
       GET REGIONS
    ============================================================= */

    async getDistRegion() {

      const token =
        localStorage.getItem('token')


      try {

        const response =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/region/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              }

            }
          )


        this.regions_array =
          response.data

      }
      catch (error) {

        console.error(
          'Error loading regions:',
          error
        )

      }

    },


    /* =============================================================
       REGION CHANGE
    ============================================================= */

    ChangeRegion() {

      this.getMAMOTHdata()

    },


    /* =============================================================
       CREATE CELL BOUNDS
    ============================================================= */

    getBoundingBox(center) {

      /*
       * Original behaviour retained.
       *
       * Distance = 1 km from center in every direction.
       */
      const distance = 1

      const R = 6371


      const dLat =
        distance / R


      const dLon =
        distance /
        (
          R *
          Math.cos(
            Math.PI /
            180 *
            center[0]
          )
        )


      const minLat =
        center[0] -
        dLat *
        180 /
        Math.PI


      const maxLat =
        center[0] +
        dLat *
        180 /
        Math.PI


      const minLon =
        center[1] -
        dLon *
        180 /
        Math.PI


      const maxLon =
        center[1] +
        dLon *
        180 /
        Math.PI


      return [

        [
          minLat,
          minLon
        ],

        [
          maxLat,
          maxLon
        ]

      ]

    },


    /* =============================================================
       LOAD GRID DATA
    ============================================================= */

    async getAllMAMOTHdata() {

      const token =
        localStorage.getItem('token')


      /*
       * Cancel an existing renderer immediately.
       */
      this.mamothRenderVersion++


      this.tst = true


      try {

        const month =
          this.months_names.indexOf(
            this.value
          ) + 1


        if (
          month <= 0
        ) {

          return

        }


        const response =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              },

              params: {

                year:
                  this.selectedYear,

                month,

                region:
                  this.selectedRegion

              }

            }
          )


        /*
         * Calculate bounds ONCE when data arrive.
         *
         * We don't recalculate them every time map moves.
         */
        this.mamoth_data =
          response.data.map(
            item => {

              return {

                ...item,

                bounds:
                  this.getBoundingBox([
                    item.y,
                    item.x
                  ])

              }

            }
          )


        /*
         * Render native Leaflet polygons.
         */
        await this.renderMAMOTHLayer()

      }
      catch (error) {

        console.error(
          'Error loading MAMOTH data:',
          error
        )


        this.mamoth_data = []


        this.clearMAMOTHLayer()


        this.modalError = true

      }
      finally {

        this.tst = false

      }

    },


    /* =============================================================
       CHANGE MODEL
    ============================================================= */

    ChangeModel() {

      if (
        this.selectedModel ===
        'MAMOTH'
      ) {

        this.getMAMOTHdata()

      }
      else {

        this.ChangeCountry()

      }

    },


    /* =============================================================
       MOSQUITO ABUNDANCE DATA
    ============================================================= */

    async MosquitoesAbundanceData() {

      const token =
        localStorage.getItem('token')


      try {

        const response =
          await axios.get(
            'mosquitoes-abundance/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              },

              params: {

                week:
                  this.value,

                year:
                  this.selectedYear,

                country:
                  this.selectedCountry,

                type:
                  'Culex'

              }

            }
          )


        this.Mosquitoes_Abundance_Data =
          response.data


        if (
          this.selectedYear > 2022
        ) {

          this.Mosquitoes_Abundance_Data =
            this.Mosquitoes_Abundance_Data.map(
              item => {

                return {

                  ...item,

                  bounds:
                    this.getBoundingBox([
                      item.y,
                      item.x
                    ])

                }

              }
            )

        }

      }
      catch (error) {

        console.error(
          'Error loading mosquito abundance:',
          error
        )

      }

    },


    /* =============================================================
       COUNTRY CHANGE
    ============================================================= */

    async ChangeCountry() {

      this.close()


      const num =
        this.countryNameArray.indexOf(
          this.selectedCountry
        )


      /*
       * Vue 2 reactivity:
       *
       * use this.$set instead of direct array index assignment.
       */
      if (
        num >= 0
      ) {

        this.$set(
          this.countryColorArray,
          num,
          '#EC008C'
        )

      }


      if (
        this.selected_country_old !== null &&
        this.selected_country_old >= 0 &&
        this.selected_country_old !== num
      ) {

        this.$set(
          this.countryColorArray,
          this.selected_country_old,
          '#3388ff'
        )

      }


      this.selected_country_old =
        num


      /*
       * Greece bounds.
       */
      if (
        this.$refs.myMap &&
        this.$refs.myMap.mapObject
      ) {

        this.$refs.myMap
          .mapObject
          .fitBounds([
            [
              40.7634502432201,
              23.9569594997323
            ],
            [
              35.8924119881264,
              23.8465820717025
            ]
          ])

      }


      await this.getMAMOTHdata()

    },


    /* =============================================================
       COLOR CLASSIFICATION
    ============================================================= */

    colors_Classification(data) {

      if (
        this.selectedCountry ===
        'Greece'
      ) {

        return MyFunctions.colors_Gr(
          data
        )

      }


      return this.colors[
        data
      ]

    },


    /* =============================================================
       CALLBACK RANGE
    ============================================================= */

    callbackRange(val) {

      this.rangeValue =
        val

    },


    /* =============================================================
       MONTH CHANGE
    ============================================================= */

    async ChangeWeek() {

      if (
        this.selectedCountry ===
        'Greece'
      ) {

        await this.getAllMAMOTHdata()

      }


      if (
        this.value === '0'
      ) {

        this.Mosquitoes_Abundance_Data =
          null

      }

    },


    /* =============================================================
       OPEN CHART
    ============================================================= */

    async openChart(i) {

      this.display =
        'block'


      this.col =
        'col-md-7'


      this.charts =
        true


      /*
       * Wait because changing Bootstrap columns changes
       * the map/chart dimensions.
       */
      await this.$nextTick()


      /*
       * Leaflet needs invalidateSize when container width changes.
       *
       * This avoids broken/laggy tiles after opening chart.
       */
      if (
        this.$refs.myMap &&
        this.$refs.myMap.mapObject
      ) {

        this.$refs.myMap
          .mapObject
          .invalidateSize({

            animate: false

          })

      }


      const lineChartsBar =
        this.$refs.lineChartsBar


      if (
        !lineChartsBar
      ) {

        return

      }


      lineChartsBar.removeSeries()


      const token =
        localStorage.getItem('token')


      try {

        const response =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/chart/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              },

              params: {

                year:
                  this.selectedYear,

                cell_id:
                  i.cell_id

              }

            }
          )


        if (
          !response.data ||
          !response.data.length
        ) {

          return

        }


        const chartData =
          response.data[0]


        const col =
          chartData.array_predictions.map(
            prediction => {

              return {

                y: prediction,

                color:
                  this.colors_Classification(
                    prediction
                  )

              }

            }
          )


        lineChartsBar
          .getChart()
          .xAxis[0]
          .setCategories(
            chartData.array_month
          )


        lineChartsBar.addSeries({

          name: 'Month',

          data: col

        })


        lineChartsBar
          .getChart()
          .setTitle({

            text:
              i.cell_id

          })

      }
      catch (error) {

        console.error(
          'Error loading chart:',
          error
        )

      }

    },


    /* =============================================================
       SETTLEMENT
    ============================================================= */

    settlementActive(i) {

      this.nameOfSettlementTooltip =
        i.settlement

    },


    /* =============================================================
       YEAR CHANGE
    ============================================================= */

    async ChangeYear() {

      if (
        this.selectedCountry !==
        'Greece'
      ) {

        this.data = []


        if (
          this.dates &&
          this.dates.length
        ) {

          for (
            let i = 0;
            i < this.dates.length;
            i++
          ) {

            this.data.push(
              this.dates[i].extractWeek
            )

          }


          this.value =
            this.data[0]

        }


        return

      }


      const token =
        localStorage.getItem('token')


      this.tst = true


      try {

        const response =
          await axios.get(
            'mosquito-borne-dieseases-risk-predictions/month/get/',
            {

              headers: {

                Authorization:
                  `Bearer ${token}`

              },

              params: {

                year:
                  this.selectedYear,

                region:
                  this.selectedRegion

              }

            }
          )


        this.data =
          response.data.map(
            item => {

              const monthName =
                this.months_names[
                  item.month - 1
                ]


              return {

                id:
                  monthName,

                name:
                  monthName

              }

            }
          )


        if (
          !this.data.length
        ) {

          this.value = null

          this.mamoth_data = []

          this.clearMAMOTHLayer()

          return

        }


        this.value =
          this.data[0].id


        await this.getAllMAMOTHdata()

      }
      catch (error) {

        console.error(
          'Error changing year:',
          error
        )

        this.modalError = true

      }
      finally {

        this.tst = false

      }

    },


    /* =============================================================
       COUNTRY POLYGON CLICK
    ============================================================= */

    focusOnCountry(index) {

      if (
        this.countryNameArray[index] !==
        this.selectedCountry
      ) {

        this.selectedCountry =
          this.countryNameArray[index]


        this.ChangeCountry()

      }

    },


    /* =============================================================
       CLOSE CHART
    ============================================================= */

    async close() {

      this.display =
        'none'


      this.col =
        'col-md-12'


      await this.$nextTick()


      /*
       * Width of map changed.
       */
      if (
        this.$refs.myMap &&
        this.$refs.myMap.mapObject
      ) {

        this.$refs.myMap
          .mapObject
          .invalidateSize({

            animate: false

          })

      }

    }

  }

}

</script>


<style>

.custom-step {

  width: 100%;

  height: 100%;

  border-radius: 50%;

  box-shadow:
    0 0 0 3px #ccc;

  background-color:
    #fff;

}


.custom-step.active {

  box-shadow:
    0 0 0 3px #00948a !important;

  background-color:
    #00948a !important;

}


.vue-slider-dot-handle {

  background-color:
    #00948a !important;

}


.vue-slider-process {

  background-color:
    #00948a !important;

}


.vue-slider-dot-tooltip-inner {

  border-color:
    #00948a !important;

  background-color:
    #00948a !important;

}


/*
 * Shared Leaflet tooltip used by all grid cells.
 */
.mamoth-tooltip {

  font-size: 11px;

  text-align: center;

  white-space: nowrap;

}


/*
 * Optional:
 *
 * Helps Canvas/map interaction feel smoother.
 */
.leaflet-container {

  will-change: transform;

}

</style>